export class AzureEntraIdSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "conditionalAccessCapture",
            "baseName": "conditionalAccessCapture",
            "type": "AzureEntraIdSnapshotPropertiesConditionalAccessCaptureEnum",
            "format": ""
        },
        {
            "name": "termsOfUseCapture",
            "baseName": "termsOfUseCapture",
            "type": "AzureEntraIdSnapshotPropertiesTermsOfUseCaptureEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureEntraIdSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureEntraIdSnapshotPropertiesConditionalAccessCaptureEnum;
(function (AzureEntraIdSnapshotPropertiesConditionalAccessCaptureEnum) {
    AzureEntraIdSnapshotPropertiesConditionalAccessCaptureEnum["Captured"] = "captured";
    AzureEntraIdSnapshotPropertiesConditionalAccessCaptureEnum["MissingPermission"] = "missingPermission";
    AzureEntraIdSnapshotPropertiesConditionalAccessCaptureEnum["NotLicensed"] = "notLicensed";
})(AzureEntraIdSnapshotPropertiesConditionalAccessCaptureEnum || (AzureEntraIdSnapshotPropertiesConditionalAccessCaptureEnum = {}));
export var AzureEntraIdSnapshotPropertiesTermsOfUseCaptureEnum;
(function (AzureEntraIdSnapshotPropertiesTermsOfUseCaptureEnum) {
    AzureEntraIdSnapshotPropertiesTermsOfUseCaptureEnum["Captured"] = "captured";
    AzureEntraIdSnapshotPropertiesTermsOfUseCaptureEnum["MissingPermission"] = "missingPermission";
    AzureEntraIdSnapshotPropertiesTermsOfUseCaptureEnum["NotLicensed"] = "notLicensed";
})(AzureEntraIdSnapshotPropertiesTermsOfUseCaptureEnum || (AzureEntraIdSnapshotPropertiesTermsOfUseCaptureEnum = {}));
